/* Display formatters shared by the site and the launcher. Moved verbatim from
   player/src/api.ts. */

export const humanSize = (b: number | null | undefined): string => {
  if (!b || b <= 0) return '—'
  if (b >= 1 << 30) return (b / (1 << 30)).toFixed(1) + ' GB'
  if (b >= 1 << 20) return Math.round(b / (1 << 20)) + ' MB'
  if (b >= 1 << 10) return Math.round(b / (1 << 10)) + ' KB'
  return b + ' B'
}

export const fmt = (n: number | null | undefined) => n == null ? '—' : Number(n).toLocaleString()
export const flag = (cc: string | null) => {
  if (!cc || cc.length !== 2 || cc === 'XX') return '🏴'
  return String.fromCodePoint(...[...cc.toUpperCase()].map(c => 0x1f1e6 + c.charCodeAt(0) - 65))
}
export const workshop = (id: string | null) => id ? `https://steamcommunity.com/sharedfiles/filedetails/?id=${id}` : null

// DayZ reports an internal map *class name* ("chernarusplus", "enoch") that reads
// badly in the UI. Map known ones to real names; clean-title-case the rest. Keep
// the raw slug for filters/queries — this is display-only. Mirrors backend map_label.
const MAP_NAMES: Record<string, string> = {
  chernarusplus: 'Chernarus', chernarus: 'Chernarus',
  enoch: 'Livonia', livonia: 'Livonia',
  namalsk: 'Namalsk', namalskcrise: 'Namalsk Crisis',
  deerisle: 'Deer Isle', sakhal: 'Sakhal', nasdara: 'Nasdara', banov: 'Banov',
  pripyat: 'Pripyat', bitterroot: 'Bitterroot', hashima: 'Hashima',
  nhchernobyl: 'Chernobyl Zone', exclusionzone: 'Exclusion Zone',
  deadfall: 'Deadfall', alteria: 'Alteria',
  chernarus2035: 'Chernarus 2035', takistanplus: 'Takistan',
  esseker: 'Esseker', valning: 'Valning', rostow: 'Rostow',
  chiemsee: 'Chiemsee', melkart: 'Melkart', swansisland: "Swan's Island",
  utes: 'Utes', iztek: 'Iztek', yiprit: 'Yiprit', rify: 'Rify',
}
export const mapLabel = (slug: string | null | undefined): string => {
  if (!slug) return '—'
  const key = slug.trim().toLowerCase()
  if (MAP_NAMES[key]) return MAP_NAMES[key]
  const base = key.replace(/(plus|map)$/, '').replace(/[_-]+/g, ' ').trim()
  return base ? base.replace(/\b\w/g, (c) => c.toUpperCase()) : slug
}
